import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class strings safely, deduping conflicting utilities.
 * Identical to the `cn` helper apps/web and apps/forms use locally,
 * just bundled inside the package so the shadcn primitives we ship
 * don't have to peer-depend on a host-provided implementation.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
